/**
 * api接口统一管理
 */

import {post,postJson,downloadAttachment} from "@/utils/http";
// import * as util from "@/assets/js/util.js";

import {SYS_APi_SCREENING_URL} from '@/utils/globals'
//文件上传
// export const fileUploadUrl =  '/upload/fileUpload';
// export const fileUploadSubmit = p =>post(util.session("projectUrl") + "/upload/fileUploadSubmit", p);
// 登录api
export const login = p => postJson(SYS_APi_SCREENING_URL + "/getToken", p);
// 验证码api
export const getCaptchaImg = p => postJson(SYS_APi_SCREENING_URL + "/captcha", p);
// 注册api
export const signup = p => postJson(SYS_APi_SCREENING_URL + "/signup", p);
export const getLoginInfo = p => postJson(SYS_APi_SCREENING_URL + "/getLoginInfo", p);

export const forgetPassword = p => post(SYS_APi_SCREENING_URL + "/user/forgetPassword", p);
// //获取渠道列表
// export const channelList = p => post(SYS_APi_EXTERNAL_URL + "/channel/getChannelListAll", p);
// export const getAllBatchByProjectId = p => post(SYS_APi_EXTERNAL_URL + "/projectWhiteBatch/getProjectWhiteBatchAllList", p);
// // export const creatKeystone = p => post(p.visitUrl+"/cer/createCer", p);
//
//
//
// //渠道上报数据
// export const getChannelDayReportList = p => post(util.session("projectUrl") + "/chanelDayCouponReport/list", p);
// export const getChannelDayReportInfo = p => post(util.session("projectUrl") + "/chanelDayCouponReport/getInfo", p);
// export const createChannelDayReportInfo = p => post(util.session("projectUrl") + "/chanelDayCouponReport/create", p);
//
// //优化到系统管理中动态数据源查询
// export const getCouponDataList = p => post(SYS_APi_EXTERNAL_URL + "/businessDataQuery/getDataList", p);
//
// export const exportCouponDataList = p => downloadAttachment(SYS_APi_EXTERNAL_URL + "/businessDataQuery/export", p);
//
// // export const getChannelWhite = p => post(util.session("projectUrl") + "/productWhiteList/getChannelWhite", p);
// export const auditWhite = p => post(SYS_APi_BASE_URL + "/businessDataQuery/auditWhite", p);
//
// export const auditWhiteBefore = p => post(SYS_APi_EXTERNAL_URL + "/businessDataQuery/auditWhiteBefore", p);
// export const getChannelWhiteList = p => post(SYS_APi_EXTERNAL_URL + "/businessDataQuery/getChannelWhiteList", p);
// export const downloadExcelY = p => downloadAttachment(SYS_APi_EXTERNAL_URL + "/businessDataQuery/downloadWhiteListY", p);
// //获取渠道批次审核列表
// export const getChannelWhiteApprove = p => post(SYS_APi_EXTERNAL_URL + "/businessDataQuery/getChannelWhiteApprove", p);